import React, { Fragment } from 'react'
import { Icon, Label } from 'semantic-ui-react'
import cn from 'classnames'
import './styles.scss'

export default function Tags({
  tags = [],
  className,
  color = 'gray-light',
  rounded,
  showEmpty
}) {
  const isEmpty = tags.length === 0

  if (isEmpty && !showEmpty) return null

  return (
    <div className={cn('flex tags-list', className)}>
      {!isEmpty
        ? tags.map(tag => (
            <Label
              key={tag.label || tag}
              className={cn('tag-item', color, { rounded })}
            >
              {typeof tag === 'object' ? (
                <Fragment>
                  {tag.icon && (
                    <Icon name={tag.icon} className='x12 label-item__icon' />
                  )}
                  {tag.label && (
                    <span className='label-item__label'>{tag.label}</span>
                  )}
                  {tag.action}
                </Fragment>
              ) : (
                tag
              )}
            </Label>
          ))
        : '--'}
    </div>
  )
}
